<template>
  <div id="main">
    <mescroll-vue class="mescroll" ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" id="listId">
      <ul class="goodlist">
        <li v-for="(item, i) in dataList" :key="i" class="white">
          <good-list :item="item" :showType="'ztk'"></good-list>
        </li>
      </ul>
    </mescroll-vue>
  </div>
</template>

<script>
import { topProductList } from '../../api/home'
export default {
  name: 'top100',
  props: {
    id: String
  },
  created () {

  },
  data () {
    return {
      dataList: [
      ], // 列表数据
      mescrollUp: {
        toTop: {
          // 回到顶部按钮
          // warpId: 'listId',
          warpClass: 'mescroll-totop-my',
          src: require('../../assets/image/common/top1.png'), // 图片路径,默认null,支持网络图
          offset: 1000 // 列表滚动1000px才显示回到顶部按钮
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  mounted () {
  },
  beforeRouteLeave (to, from, next) {
    next()
  },
  methods: {
    // 下拉刷新
    downCallback (val) {
      this.mescroll.endSuccess()
    },
    // 上拉加载
    upCallback (val) {
      console.log(val)
      let data = {
        pageNo: val.num,
        pageSize: val.size
      }
      if (val.num === 1) {
        this.dataList = []
      }
      topProductList(data).then(res => {
        if (res.result === '0') {
          if (val.num === 1) {
            this.dataList = []
          }
          res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
          this.mescroll.endByPage(res.dataList ? res.dataList.length:0, res.totalPage)
        }else {
          this.mescroll.endErr()
        }
      }, err => {
        this.mescroll.endErr()
      })
    }
  }
}
</script>

<style scoped>
  /*#main{*/
  /*  height: calc(100vh - 150px);*/
  /*  overflow: auto;*/
  /*}*/
  .mescroll{
    position: fixed;
    top: 100px;/*no*/
    bottom: 50px;/*no*/
    height: auto; /*如设置bottom:50px,则需height:auto才能生效*/
  }
  .goodlist li{
    padding: 2% 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/home/top100.vue